"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("b-modal", {
    attrs: {
      active: _vm.isModalActive,
      width: 720,
      "has-modal-card": "",
      scroll: "keep",
      "trap-focus": ""
    },
    on: {
      close: _vm.handleClose
    }
  }, [_c("form", {
    staticClass: "modal-card",
    on: {
      submit: function submit($event) {
        $event.preventDefault();
        return _vm.submitForm.apply(null, arguments);
      }
    }
  }, [_c("header", {
    staticClass: "modal-card-head"
  }, [_c("p", {
    staticClass: "modal-card-title"
  }, [_vm._v("\n        " + _vm._s(_vm.isEdit ? "Editar contrato" : "Registrar contrato") + "\n      ")]), _vm._v(" "), _c("button", {
    staticClass: "delete",
    attrs: {
      type: "button"
    },
    on: {
      click: _vm.handleClose
    }
  })]), _vm._v(" "), _c("section", {
    staticClass: "modal-card-body"
  }, [_c("div", {
    staticClass: "form-grid"
  }, [_c("AutocompleteSelect", {
    attrs: {
      items: _vm.customerItems,
      "on-fetch": _vm.fetchCustomers,
      label: "Cliente",
      placeholder: "Buscar cliente...",
      "selection-property": "id",
      "label-property": "name",
      multiple: false,
      "show-selected-list": false
    },
    model: {
      value: _vm.form.clientId,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "clientId", $$v);
      },
      expression: "form.clientId"
    }
  }), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Número do contrato"
    }
  }, [_c("b-input", {
    attrs: {
      placeholder: "Contrato",
      maxlength: "60",
      required: ""
    },
    model: {
      value: _vm.form.contractNumber,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "contractNumber", typeof $$v === "string" ? $$v.trim() : $$v);
      },
      expression: "form.contractNumber"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Data de assinatura"
    }
  }, [_c("b-datepicker", {
    attrs: {
      icon: "calendar-today",
      placeholder: "Selecione a data",
      required: ""
    },
    model: {
      value: _vm.form.signatureDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "signatureDate", $$v);
      },
      expression: "form.signatureDate"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Prazo de pagamento"
    }
  }, [_c("b-datepicker", {
    attrs: {
      icon: "calendar-today",
      placeholder: "Selecione a data",
      required: ""
    },
    model: {
      value: _vm.form.paymentTermDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "paymentTermDate", $$v);
      },
      expression: "form.paymentTermDate"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Data de entrega"
    }
  }, [_c("b-datepicker", {
    attrs: {
      icon: "calendar-today",
      placeholder: "Selecione a data",
      required: ""
    },
    model: {
      value: _vm.form.deliveryDate,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "deliveryDate", $$v);
      },
      expression: "form.deliveryDate"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Total de mudas previstas"
    }
  }, [_c("b-input", {
    attrs: {
      type: "number",
      min: "1",
      placeholder: "0",
      required: ""
    },
    model: {
      value: _vm.form.totalPlants,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "totalPlants", _vm._n($$v));
      },
      expression: "form.totalPlants"
    }
  })], 1), _vm._v(" "), _c("b-field", {
    attrs: {
      label: "Tipo de lote"
    }
  }, [_c("b-select", {
    attrs: {
      placeholder: "Selecione o tipo",
      expanded: "",
      required: ""
    },
    model: {
      value: _vm.form.lotType,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lotType", $$v);
      },
      expression: "form.lotType"
    }
  }, [_c("option", {
    attrs: {
      disabled: ""
    },
    domProps: {
      value: null
    }
  }, [_vm._v("\n              Selecione o tipo\n            ")]), _vm._v(" "), _vm._l(_vm.lotTypeOptions, function (option) {
    return _c("option", {
      key: option.value,
      domProps: {
        value: option.value
      }
    }, [_vm._v("\n              " + _vm._s(option.label) + "\n            ")]);
  })], 2)], 1)], 1), _vm._v(" "), _c("AutocompleteSelect", {
    attrs: {
      items: _vm.lotsItems,
      "on-fetch": _vm.fetchLots,
      label: "Lotes vinculados",
      placeholder: "Buscar e selecionar lotes...",
      "selection-property": "id",
      "label-property": "title",
      multiple: true
    },
    model: {
      value: _vm.form.lotIds,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "lotIds", $$v);
      },
      expression: "form.lotIds"
    }
  })], 1), _vm._v(" "), _c("footer", {
    staticClass: "modal-card-foot"
  }, [_c("b-button", {
    staticClass: "plant-nursery-primary-btn",
    attrs: {
      "native-type": "submit",
      type: "is-primary",
      loading: _vm.isSaving,
      disabled: _vm.isSaving
    }
  }, [_vm._v("\n        " + _vm._s(_vm.isEdit ? "Atualizar" : "Registrar") + "\n      ")]), _vm._v(" "), _c("b-button", {
    attrs: {
      type: "is-text"
    },
    on: {
      click: _vm.handleClose
    }
  }, [_vm._v("\n        Cancelar\n      ")])], 1)])]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;